import { errorUpdater, loaderUpdater, pageState } from 'State/page'
import type { CallbackInterface } from 'recoil'

import type { PageStateType } from 'Types/state'

import {
  fetchEmptyState,
  getEmailSubscriptionsData,
  getEngagementChartData,
  getOptoutData,
  getSmsSubscriptionsData,
} from 'Pages/RecipientsOverview/recoil/services/overview'
import { modalEngagementUpsellingState } from 'Pages/RecipientsOverview/recoil/state/modalEngagementUpselling'
import {
  emptyStateState,
  engagementChartState,
  optoutChartState,
  subscriptionsEmailState,
  subscriptionsSmsState,
} from 'Pages/RecipientsOverview/recoil/state/overview'
import type { ChartWidgetState } from 'Pages/RecipientsOverview/types'

import { logAppError } from 'Helpers/logger'

export const initPageCallback =
  ({ set, snapshot, ...cbi }: CallbackInterface) =>
  async () => {
    //
    set(pageState, loaderUpdater(true))

    try {
      const isEmptyState = await fetchEmptyState()

      set(emptyStateState, isEmptyState)
      /*
      if (isEmptyState) {
        set(emptyStateState, true)
      } else {
        const [
          subscriptionsEmail,
          suscriptionsSms,
          optoutChartData,
          engagementData
        ] = await fetchRecipientsData()

        set(subscriptionsEmailState, subscriptionsEmail)
        set(subscriptionsSmsState, suscriptionsSms)
        set(optoutChartState, optoutChartData)
        set(engagementChartState, engagementData)
      }
      */

      set<PageStateType>(pageState, (prev) => ({
        ...prev,
        status: 'ready',
      }))
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'RecipientsOverview',
        Method: 'initPageCallback',
        appError: error,
      })
      set(pageState, errorUpdater)
    }

    set(pageState, loaderUpdater(false))
    //

    void loadSubscriptionsEmailCallback({ set, snapshot, ...cbi })()
    void loadSubscriptionsSmsCallback({ set, snapshot, ...cbi })()
    void loadOptoutCallback({ set, snapshot, ...cbi })()
    void loadEngagementCallback({ set, snapshot, ...cbi })()
  }

export const resetPageCallback =
  ({ reset }: CallbackInterface) =>
  async (): Promise<void> => {
    reset(pageState)

    reset(emptyStateState)

    reset(subscriptionsEmailState)
    reset(subscriptionsSmsState)
    reset(optoutChartState)
    reset(engagementChartState)

    reset(modalEngagementUpsellingState)
  }

export const loadSubscriptionsEmailCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set<ChartWidgetState>(subscriptionsEmailState, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    try {
      const data = await getEmailSubscriptionsData()

      set<ChartWidgetState>(subscriptionsEmailState, (prev) => ({
        ...prev,
        data,
        status: 'ready',
      }))
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'RecipientsOverview',
        Method: 'loadSubscriptionsEmailCallback',
        appError: error,
      })
      set<ChartWidgetState>(subscriptionsEmailState, (prev) => ({
        ...prev,
        status: 'error',
      }))
    }

    set(subscriptionsEmailState, (prev) => ({ ...prev, loading: false }))
  }

export const loadSubscriptionsSmsCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set<ChartWidgetState>(subscriptionsSmsState, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    try {
      const data = await getSmsSubscriptionsData()

      set<ChartWidgetState>(subscriptionsSmsState, (prev) => ({
        ...prev,
        data,
        status: 'ready',
      }))
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'RecipientsOverview',
        Method: 'subscriptionsSmsState',
        appError: error,
      })
      set<ChartWidgetState>(subscriptionsSmsState, (prev) => ({
        ...prev,
        status: 'error',
      }))
    }

    set(subscriptionsSmsState, (prev) => ({ ...prev, loading: false }))
  }

export const loadOptoutCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set<ChartWidgetState>(optoutChartState, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    try {
      const data = await getOptoutData()

      set<ChartWidgetState>(optoutChartState, (prev) => ({
        ...prev,
        data,
        status: 'ready',
      }))
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'RecipientsOverview',
        Method: 'loadOptoutCallback',
        appError: error,
      })
      set<ChartWidgetState>(optoutChartState, (prev) => ({
        ...prev,
        status: 'error',
      }))
    }

    set(optoutChartState, (prev) => ({ ...prev, loading: false }))
  }

export const loadEngagementCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set<ChartWidgetState>(engagementChartState, (prev) => ({
      ...prev,
      loading: true,
      status: 'initial',
    }))

    try {
      const { data, upselling } = await getEngagementChartData()

      set<ChartWidgetState>(engagementChartState, (prev) => ({
        ...prev,
        data,
        upselling,
        status: 'ready',
      }))
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'RecipientsOverview',
        Method: 'engagementChartState',
        appError: error,
      })
      set<ChartWidgetState>(engagementChartState, (prev) => ({
        ...prev,
        status: 'error',
      }))
    }

    set(engagementChartState, (prev) => ({ ...prev, loading: false }))
  }
